


import TwoLevelsSelector from '@/shared/components/twoLevelsSelector/TwoLevelsSelector.component.vue';
import { Component, Vue } from 'vue-property-decorator';

import { SecondLevelOptionModel } from '@/shared/models/secondLevelOption.model';

@Component({
  components: {
      TwoLevelsSelector,
  },
})

export default class PartialTwoLevelsSelector extends Vue {
  private optionSelected1?: SecondLevelOptionModel = new SecondLevelOptionModel();
  private optionSelected2?: SecondLevelOptionModel = new SecondLevelOptionModel();
  private disabled1 = false;
  private disabled2 = true;
  private firstLevelOptions = [
      {
          value: '1',
          label: 'Alicante',
          options: [
              new SecondLevelOptionModel(
                  '32',
                  '14 y 15 de septiembre de 2018',
                  false,
                  '',
                  false,
              ),
              new SecondLevelOptionModel(
                  '42',
                  '30 de nov y 1 de dic de 2018',
                  false,
                  '',
                  false,
              ),
              new SecondLevelOptionModel(
                  '36',
                  '7 y 8 de marzo de 2019',
                  false,
                  '',
                  false,
              ),
              new SecondLevelOptionModel(
                  '54',
                  '23 y 28 de mayo de 2019',
                  false,
                  '',
                  false,
              ),
              new SecondLevelOptionModel(
                  '68',
                  '13 y 14 de septiembre de 2019',
                  true,
                  'Fecha posterior a Curso Nivel 2',
                  false,
              ),
              new SecondLevelOptionModel(
                  '61',
                  '28 y 29 de noviembre de 2019',
                  true,
                  'Fecha posterior a Curso Nivel 2',
                  false,
              ),
          ],
      },
      {
          value: '2',
          label: 'Barcelona',
          options: [
              new SecondLevelOptionModel(
                  '72',
                  '21 y 22 de septiembre de 2018',
                  false,
                  '',
                  false,
              ),
              new SecondLevelOptionModel(
                  '44',
                  '26 y 27 de diciembre de 2018',
                  false,
                  '',
                  false,
              ),
              new SecondLevelOptionModel(
                  '48',
                  '2 y 3 de marzo de 2019',
                  true,
                  'Fecha posterior a Curso Nivel 2',
                  false,
              ),
              new SecondLevelOptionModel(
                  '81',
                  '21 y 22 de junio de 2019',
                  true,
                  'Fecha posterior a Curso Nivel 2',
                  false,
              ),
          ],
      },
      {
          value: '3',
          label: 'Madrid',
          options: [
              new SecondLevelOptionModel(
                  '172',
                  '7 y 8 de septiembre de 2018',
                  false,
                  '',
                  false,
              ),
              new SecondLevelOptionModel(
                  '244',
                  '26 y 27 de febrero de 2019',
                  false,
                  '',
                  false,
              ),
          ],
      },
      {
          value: '4',
          label: 'Málaga',
          options: [
              new SecondLevelOptionModel(
                  '372',
                  '28 y 29 de septiembre de 2018',
                  false,
                  '',
                  false,
              ),
              new SecondLevelOptionModel(
                  '444',
                  '12 y 13 de diciembre de 2018',
                  false,
                  '',
                  false,
              ),
              new SecondLevelOptionModel(
                  '548',
                  '12 y 13 de mayo de 2019',
                  false,
                  '',
                  false,
              ),
              new SecondLevelOptionModel(
                  '681',
                  '21 y 22 de septiembre de 2019',
                  false,
                  '',
                  false,
              ),
          ],
      },
      {
          value: '5',
          label: 'Palma de Mallorca',
          options: [
              new SecondLevelOptionModel(
                  '772',
                  '16 y 17 de septiembre de 2018',
                  false,
                  '',
                  false,
              ),
              new SecondLevelOptionModel(
                  '848',
                  '6 y 7 de febrero de 2019',
                  true,
                  'Fecha posterior a Curso Nivel 2',
                  false,
              ),
          ],
      },
      {
          value: '6',
          label: 'Valencia',
          options: [
              new SecondLevelOptionModel(
                  '972',
                  '12 y 13 de octubre de 2018',
                  false,
                  '',
                  false,
              ),
              new SecondLevelOptionModel(
                  '1044',
                  '11 y 12 de abril de 2019',
                  false,
                  '',
                  false,
              ),
          ],
      },
      {
          value: '7',
          label: 'Zaragoza',
          options: [
              new SecondLevelOptionModel(
                  '1172',
                  '21 y 22 de noviembre de 2018',
                  false,
                  '',
                  false,
              ),
              new SecondLevelOptionModel(
                  '1244',
                  '26 y 27 de enero de 2019',
                  false,
                  '',
                  false,
              ),
              new SecondLevelOptionModel(
                  '1381',
                  '21 y 22 de mayo de 2019',
                  true,
                  'Fecha posterior a Curso Nivel 2',
                  false,
              ),
          ],
      },
  ];
  private firstLevelOptionInitialIndex1 = 5;
  private firstLevelOptionInitialIndex2 = 2;
}

